import { BellOutlined, CheckOutlined, DeleteOutlined } from '@ant-design/icons';
import {
  Badge,
  Button,
  Divider,
  Dropdown,
  List,
  Space,
  Tooltip,
  Typography,
} from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import {
  getNotifications,
  getUnreadCount,
  markAsRead,
  markAllAsRead,
  deleteNotification,
} from '../actions/NotificationAction';
import { URL_NOTIFICATIONS } from '../constants/URLS';
import { formatEventTypeLabel } from '../utils/notificationUtils';

const { Text } = Typography;

const NotificationHeader = props => {
  const dispatch = useDispatch();
  const { notifications, unreadCount } = useSelector(
    (state: AppState) => state.notification
  );

  useEffect(() => {
    dispatch(getNotifications(1, 10));
    dispatch(getUnreadCount());
  }, [dispatch]);

  const badgeCount = unreadCount || 0;

  const content = (
    <DropdownContainer>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Text strong>Notifications</Text>
        {badgeCount > 0 && (
          <Link
            to="#"
            onClick={e => {
              e.preventDefault();
              dispatch(markAllAsRead());
            }}
          >
            Mark all as read
          </Link>
        )}
      </div>
      <Divider style={{ margin: '8px 0' }} />
      <List
        size="small"
        dataSource={notifications}
        locale={{ emptyText: 'No notifications' }}
        renderItem={item => (
          <List.Item
            style={{
              background: item.is_read ? 'transparent' : '#f6ffed',
              padding: '8px',
              cursor: 'default',
            }}
            actions={([
              !item.is_read && (
                <Tooltip title="Mark as read" key="read">
                  <Button
                    type="text"
                    size="small"
                    icon={<CheckOutlined />}
                    onClick={() => dispatch(markAsRead(item.id))}
                  />
                </Tooltip>
              ),
              <Tooltip title="Delete" key="delete">
                <Button
                  type="text"
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={() => dispatch(deleteNotification(item.id))}
                />
              </Tooltip>,
            ] as JSX.Element[]).filter(Boolean)}
          >
            <List.Item.Meta
              title={
                <Space size={4}>
                  <Text strong={!item.is_read} style={{ fontSize: 13 }}>
                    {item.subject || formatEventTypeLabel(item.event_type)}
                  </Text>
                  <Text type="secondary" style={{ fontSize: 11 }}>
                    {formatEventTypeLabel(item.event_type)}
                  </Text>
                </Space>
              }
              description={
                <Text type="secondary" style={{ fontSize: 12 }} ellipsis>
                  {item.message}
                </Text>
              }
            />
          </List.Item>
        )}
      />
      <Divider style={{ margin: '8px 0' }} />
      <div style={{ textAlign: 'center' }}>
        <Link to={URL_NOTIFICATIONS}>View all notifications</Link>
      </div>
    </DropdownContainer>
  );

  return (
    <Dropdown overlay={content} trigger={['click']} placement="bottomRight">
      <Badge count={badgeCount}>
        <Button
          style={props.style || {}}
          icon={<BellOutlined />}
          shape="circle"
        />
      </Badge>
    </Dropdown>
  );
};

const DropdownContainer = styled.div`
  width: 360px;
  max-height: 400px;
  overflow-y: auto;
  background: white;
  padding: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
`;

export default NotificationHeader;
